package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun DividerWithText(
    text: String = "ou",
    modifier: Modifier = Modifier,
    width: CSSSizeValue<CSSUnit.px> = 1500.px
) {
    Row(
        modifier = modifier
            .width(width)
            .margin(top = 40.px, bottom = 20.px),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Div(
            attrs = Modifier
                .flex(1)
                .height(1.px)
                .backgroundColor(Colors.lineBorder)
                .toAttrs()
        )

        SpanText(
            text = text,
            modifier = Modifier
                .fontSize(14.px)
                .fontFamily(INTER)
                .color(Colors.Graytext)
                .margin(leftRight = 5.px)
        )

        Div(
            attrs = Modifier
                .flex(1)
                .height(1.px)
                .backgroundColor(Colors.lineBorder)
                .toAttrs()
        )
    }
}